import { ToastComponent } from './toast/toast.component';

export const components = [ToastComponent];
export const entryComponents = [ToastComponent];

export * from './toast/toast.component';
